export default "__VITE_ASSET__vfiBXvEs__"